var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReports = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 37,
  fill: "none",
  viewBox: "0 0 36 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M29 14.335v15.798c0 1.864-.497 2.367-2.333 2.367H9.333C7.496 32.5 7 31.997 7 30.133V6.867C7 5.003 7.496 4.5 9.333 4.5h9.913a.5.5 0 1 0 0-1H9.333C6.941 3.5 6 4.454 6 6.867v23.266c0 2.413.941 3.367 3.333 3.367h17.334c2.392 0 3.333-.954 3.333-3.367V14.335a.5.5 0 1 0-1 0M12.5 12.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V13a.5.5 0 0 1 .5-.5m6 6.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0zm5 1.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M20 4.578a1 1 0 0 1 1.707-.707l7.922 7.922a1 1 0 0 1-.707 1.707H22a2 2 0 0 1-2-2zm1 6.922a1 1 0 0 0 1 1h6.922L21 4.578z",
  clipRule: "evenodd"
})));
export default SvgReports;